import { createRoot } from "react-dom/client";
import { App } from "./App.jsx";
import "keep-straight-design-system/css/kit.css";
import "keep-straight-design-system/css/interactive.css";
import "./styles/spec.css";

createRoot(document.getElementById("root")).render(<App />);
